/** Mapa categoria do blog -> pós da FEO recomendada no CTA do artigo. */
export interface PosCtaInfo {
  nome: string;
  descricao: string;
  to: string;
}

const POS: Record<string, PosCtaInfo> = {
  orto: {
    nome: "Pós em Fisioterapia Ortopédica",
    descricao: "Raciocínio clínico, avaliação e reabilitação ortopédica com base em evidência.",
    to: "/ementa-orto",
  },
  dor: {
    nome: "Pós em Fisioterapia em Dor",
    descricao: "Neurociência da dor, dor persistente e manejo clínico centrado na pessoa.",
    to: "/ementa-dor",
  },
  esporte: {
    nome: "Pós em Fisioterapia Esportiva",
    descricao: "Performance, prevenção de lesões e retorno ao esporte com critérios objetivos.",
    to: "/ementa-esporte",
  },
  trauma: {
    nome: "Pós em Fisioterapia em Traumatologia",
    descricao: "Fraturas, pós-operatório e reabilitação do trauma musculoesquelético.",
    to: "/ementa-trauma",
  },
  geronto: {
    nome: "Pós em Fisioterapia em Gerontologia",
    descricao: "Envelhecimento, funcionalidade e populações especiais na prática clínica.",
    to: "/ementa-geronto",
  },
};

const BY_CATEGORIA: Record<string, keyof typeof POS> = {
  mmii: "orto",
  mmss: "orto",
  avaliacao: "orto",
  "coluna-vertebral": "dor",
  dor: "dor",
  "dor-orofacial": "dor",
  esporte: "esporte",
  traumatologia: "trauma",
  "populacoes-especiais": "geronto",
};

const FALLBACK: PosCtaInfo = {
  nome: "Pós-graduações da FEO",
  descricao: "Seis pós-graduações em fisioterapia, com professores referência no país.",
  to: "/pos",
};

export function posParaCategorias(categorias: string[] | null | undefined): PosCtaInfo {
  for (const cat of categorias ?? []) {
    const key = BY_CATEGORIA[cat];
    if (key) return POS[key];
  }
  return FALLBACK;
}
